
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

export { mathTrunc as default };
//# sourceMappingURL=math-trunc.js.map
